// Font file generated using: https://icomoon.io/app
// Go to the above website upload the svg file that can be downloaded from fontawesome.com
// Codes below that start with "f" are the corresponding codes for the icon on fontawesome.com

class Regular {
    private f0e2: string = "";
    private f053: string = "";
    private f054: string = "";
    private f071: string = "";
    private f356: string = "";

    public arrow_rotate_left: string = this.f0e2;
    public chevron_left: string = this.f053;
    public chevron_right: string = this.f054;
    public triangle_exclamation: string = this.f071;
    public right: string = this.f356;
}

class Solid {
    private _3f: string = "";
    private f00c: string = "";
    private f00d: string = "";
    private f015: string = "";
    private f060: string = "";
    private f061: string = "";
    private f1b0: string = "";
    private f111: string = "";
    private f356: string = "";
    private f363: string = "";
    private f6a8: string = "";
    private f130: string = "";
    private f04d: string = "";
    private f110: string = "";
    private f05a: string = "";

    public arrow_left: string = this.f060;
    public arrow_right: string = this.f061;
    public check: string = this.f00c;
    public circle: string = this.f111;
    public house: string = this.f015;
    public paw: string = this.f1b0;
    public question: string = this._3f;
    public repeat: string = this.f363;
    public right: string = this.f356;
    public volume: string = this.f6a8;
    public xmark: string = this.f00d;
    public microphone: string = this.f130;
    public stop: string = this.f04d;
    public spinner: string = this.f110;
    public circle_info: string = this.f05a;
}
export default class Fa {
    public static regular: Regular = new Regular();
    public static solid: Solid = new Solid();
}
